import clsx from 'clsx';
import * as R from 'ramda';

import { gwrrSchema } from '@atom/constants/customReportSchemaConstants';
import { InventoryAssetTreeStateType } from '@atom/types/inventory';

import ElementAssessmentRow from './ElementAssessmentRow';
import ElementAssessmentRowDeck from './ElementAssessmentRowDeck';

import classes from '../workOrderDetailPdfReport.module.css';

interface Props {
  elements: InventoryAssetTreeStateType[];
  elementName: string;
  elementGroupName?: string;
}

const ElementAssessmentTable = ({ elements, elementName }: Props) => {
  const containsSpecificAttributes = (attributeIds: string[]) => {
    return elements.reduce((acc, element) => {
      const hasAttributes = R.keys(element.attributes).reduce(
        (innerAcc, attributeId) => {
          return attributeIds.includes(String(attributeId)) || innerAcc;
        },
        false,
      );

      return hasAttributes || acc;
    }, false);
  };

  const specificAttributeIds = R.values(
    R.pick(['boredAtId', 'shellId', 'voidId'], gwrrSchema.poolAttributes),
  );

  const showColumns = containsSpecificAttributes(specificAttributeIds);

  const schemaIds = R.values(
    showColumns
      ? gwrrSchema.poolAttributes
      : R.omit(['boredAtId', 'shellId', 'voidId'], gwrrSchema.poolAttributes),
  );

  const getElementValueRows = () =>
    elements.map(element =>
      elementName.includes('Deck') ? (
        <ElementAssessmentRowDeck
          element={element}
          schemaIds={Object.values(schemaIds)}
        />
      ) : (
        <ElementAssessmentRow
          element={element}
          schemaIds={Object.values(schemaIds)}
        />
      ),
    );

  return (
    <div className={classes.tableWrapper}>
      <table>
        <thead>
          <tr>
            <th colSpan={schemaIds.length + 1}>
              <div className={classes.tableHeader}>
                {elementName} Element Assessment Details
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr className={classes.tableSubheader}>
            <th className={classes.tableHeaderCell}>Element</th>
            <th className={classes.tableHeaderCell}>Condition Rating</th>
            {showColumns && (
              <>
                <th className={classes.tableHeaderCell}>Bored At</th>
                <th className={classes.tableHeaderCell}>Shell</th>
                <th className={classes.tableHeaderCell}>Void</th>
              </>
            )}
            <th className={clsx(classes.tableHeaderCell, classes.comment)}>
              Comment
            </th>
            <th className={classes.tableHeaderCell}>Repair Recommendation</th>
            <th className={classes.tableHeaderCell}>Priority Rating</th>
            <th className={classes.tableHeaderCell}>Assessment Flag</th>
          </tr>
          {getElementValueRows()}
        </tbody>
      </table>
    </div>
  );
};

export default ElementAssessmentTable;
